"use strict";
import Common from "./Common";
import gameConfig from"../assets/data/config";

//--global display array used for cleanup--//
const disp = [];

export default class GameScene extends p3.Scene {
    constructor() {
        super();

        this._running = false;

        //--reset common display obj array--//
        Common.displayObjs = [];

        /**
         * @type {number}
         */
        this.maxCamEase = 1;

        /**
         * Flag to switch between tweenJs and TweenMax
         * @type {boolean}
         */
        this.useTweenMax = true;

        const config = gameConfig;

        /**
         * @type {number}
         * @private
         */
        this._numStars = config.numStars;

        /**
         * @type {number}
         * @private
         */
        this._numObs = config.numObs;

        /**
         * @type {number}
         * @private
         */
        this._numBalloons = config.numBalloons;

        /**
         * @type {number}
         * @private
         */
        this._maxDx = config.maxDx;

        /**
         * @type {number}
         * @private
         */
        this._boostPower = config.boostPower;

        /**
         * @type {number}
         * @private
         */
        this._gravity = config.gravity;

        /**
         * @type {number}
         * @private
         */
        this._bouncePushForward = config.bouncePushForward;

        /**
         * @type {number}
         * @private
         */
        this._yBounceFactor = config.yBounceFactor;

        /**
         * Chance of on stars on obs
         * @type {number}
         */
        this.starChance = config.starChance;

        /**
         * Chance of landing on dirt
         * @type {number}
         */
        this.chanceNoneObs = config.chanceNoneObs;

        /**
         * Basic length of course
         * @type {number}
         */
        this.basicLength = config.basicLength;

        /**
         * Additional random extra length
         * @type {number}
         */
        this.randomLength = config.randomLength;

        /**
         * @type {number}
         */
        this.randomObsDist = config.randomObsDist;

        /**
         * Minimum angle of cannon launch (max pointing upwards)
         * @type {number}
         */
        this.minRotation = config.minCannonRot;

        /**
         * Tilt back angle when happo travels upwards
         * @type {number}
         */
        this.happoBackRotation = config.happoBackRot;

        /**
         * @type {number}
         */
        this.backTimeFactor = config.happoBackRotTimeFactor;

        /**
         * Tilt forward angle when happo travels down
         * @type {number}
         */
        this.happoForwardRotation = config.happoForwRot;

        /**
         * @type {number}
         */
        this.forwardTimeFactor = config.happoForwRotTimeFactor;

        /**
         * @type {number}
         * @private
         */
        this._speedMin = config.happoMinSpeed;

        /**
         * @type {number}
         * @private
         */
        this._speedMax = config.happoMaxSpeed;

        /**
         * @type {number}
         * @private
         */
        this._bounceHeightFactor = config.bounceHeightFactor;

        /**
         * @type {number}
         * @private
         */
        this._speed = this._speedMin;

        /**
         * @type {JSON}
         */
        this._starBurstConfig = Common.assets.getJSON("particles_pickup");

        /**
         * @type {number}
         */
        this.tileSize = 1022;

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._mapHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._gameHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._uIntHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._back = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._bgHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._midBackHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._midHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._fgHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._particleHolder = new PIXI.Container();

        /**
         * @type {Array}
         * @private
         */
        this._containers = [];

        /**
         * @type {*}
         * @private
         */
        this._floorPosition = {x: 0, y: p3.View.height + 125};

        /**
         * @type {PIXI.Spine}
         * @private
         */
        this._happo = null;

        /**
         * @type {!PIXI.Point}
         * @private
         */
        this._startPos = {x: 0, y: p3.View.height};

        /**
         *  Records total distance from start
         * @type {number}
         * @private
         */
        this._totalDist = 0;

        /**
         * Text displaying distance travelled
         * @type {PIXI.Text}
         * @private
         */
        this._distanceText = null;


        /**
         * Text displaying number of stars
         * @type {null}
         * @private
         */
        this._starsText = null;

        /**
         *
         * @type {Array}
         * @private
         */
        this._stars = [];

        /**
         * Used to check player has launched the happo
         * @type {boolean}
         * @private
         */
        this._launched = false;

        /**
         * @type {number}
         * @private
         */
        this._starsCollected = 0;

        /**
         * Push particle emitters onto this so they get updated
         * @type {Array}
         * @private
         */
        this._particleEmitters = [];

        /**
         * textures for objects you bounce off
         * @type {object}
         */
        this.objTextures = config.objTextures;

        /**
         * textures for objects you bounce off
         * @type {object}
         */
        this.bounceFactors = config.bounceFactors;

        /**
         * @type {object}
         */
        this.sounds = config.sounds;

        /**
         * @type {Array}
         * @private
         */
        this._objects = [];

        /**
         * @type {Array}
         * @private
         */
        this._oldObjects = [];

        /**
         * @type {PIXI.TilingSprite}
         * @private
         */
        this._sky = null;

        /**
         * @type {null}
         * @private
         */
        this._alien = null;

        /**
         * @type {String|PIXI.Sprite}
         * @private
         */
        this._trackTarg = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this._gameHolder.addChild(this._trackTarg);//created empty sprite and add to holder to get correct location relative to holder

        /**
         * @type {*[]}
         * @private
         */
        this._blurFilter = [new PIXI.filters.BlurFilter(2, 1)];

        /**
         * @type {boolean}
         * @private
         */
        this._shownAlienThisGame = false;

        /**
         * @type {boolean}
         * @private
         */
        this._finishedIntro = false;

        /**
         * @type {Array}
         * @private
         */
        this._clouds = [];

        /**
         * @type {number}
         * @private
         */
        this._alienOffset = {x: -350};

        /**
         * @type {null}
         * @private
         */
        this._rotTween = null;

        /**
         * @type {Array}
         * @private
         */
        this._happos = [];

        /**
         * @type {boolean}
         * @private
         */
        this._justLaunched = true;
    }

    init() {

        //add to containers
        this._mapHolder.addChild(this._back, this._bgHolder, this._midBackHolder, this._midHolder, this._gameHolder, this._particleHolder, this._fgHolder);
        this.addChild(this._mapHolder, this._uIntHolder);
        this._containers = [this._back, this._bgHolder, this._midBackHolder, this._midHolder, this._gameHolder, this._particleHolder, this._fgHolder, this._mapHolder, this._uIntHolder];

        //init world
        this.initWorld();

        //init ui
        this.initUI();

        //--start audio playing--//
        Common.audio.playMusic("music_ready_loop_012");
        Common.audio.playSound("sfx_ambient_desert_loop_00", true);
        //howl.stop();
        // howl._sounds[0]._start = 0.05;
        // howl.play();
        //  console.log(howl);
        /*
         let music = Common.audio.playSound("music_ready_loop_012");
         music.on("end", ()=> {
         music.seek(0.051);
         music.play();
         });
         */
        this._mapHolder.scale.set(0.75);

        this.start();
        this.lastObjHei = this._floorPosition.y;

        var _debug = () => {
            console.log(this._happo.x + ", " + this._happo.y);
            delay(_debug, 1, this);
        };
        // _debug();

        this.randomise();

        //--bring to front--//
        this._gameHolder.addChild(this._happo);
    }

    /**
     * Called after there are no more obstacles ahead, simply resuses the old ones by moving them all ahead of the player again
     */
    repopulate() {
        //--not sure need this weirdness but just want to make sure I leave one full and the other empty--//
        this._objects = [];
        this._objects = this._objects.concat(this._oldObjects);
        this._oldObjects = [];

        //give it a lil shuffle for more variety
        this._objects = Common.shuffleArr(this._objects);

        for (let i in this._objects) {
            const obj = this._objects[i];
            obj.x = this._happo.x + i * 8000 + ((Math.random() * 6000) - 3000) + 5000;
            obj.collided = false;
        }
    }

    /**
     * randomises the level
     */
    randomise() {

        const totalStars = this._numStars;
        const totalObjs = this._numObs;
        const totalBalloons = this._numBalloons;

        for (let i = 0; i < totalStars; i++) {
            const star = createSprite("star", this._gameHolder);
            star.x = this._happo.x + i * 500 + (Math.random() * 75 - 75) + 1000;
            star.y = this._floorPosition.y - (Math.random() * 5000) - 75;
            this._stars.push(star);
        }

        for (let i = 0; i < totalObjs; i++) {
            let rand = Math.floor(Math.random() * (Object.keys(this.objTextures).length));
            let obj = createSprite(this.objTextures[rand], this._gameHolder);
            obj.type = this.objTextures[rand];
            if (i > 0) obj.x = this._happo.x + i * 8000 + ((Math.random() * 6000) - 3000) + 5000;
            else obj.x = this._happo.x + 1100;
            obj.y = this._floorPosition.y + 50;
            obj.anchor.set(0.5, 1);
            obj.collided = false;
            this._objects.push(obj);
        }

        for (let i = 0; i < totalBalloons; i++) {
            const balloon = createSprite("balloons", this._gameHolder);
            balloon.type = "balloons";
            balloon.x = this._happo.x + i * 8000 + ((Math.random() * 6000) - 3000) + 5000;
            balloon.y = this._floorPosition.y - Math.random() * 1000 - 1000;
            balloon.anchor.set(0.5, 1);
            balloon.collided = false;
            this._objects.push(balloon);
        }

        //add a few objs at begining
        for (let i = 1; i <= 4; i++) {
            let rand = Math.floor(Math.random() * (Object.keys(this.objTextures).length));
            let obj = createSprite(this.objTextures[rand], this._gameHolder);
            obj.type = this.objTextures[rand];
            obj.x = this._objects[0].x + i * 1600;
            obj.y = this._floorPosition.y + 50;
            obj.anchor.set(0.5, 1);
            obj.collided = false;
            this._objects.push(obj);
        }
    }

    updateHappo() {

        //--prevent happo going too fast--//
        if (this._happo.dx > this._maxDx) this._happo.dx = this._maxDx;

        //--bounce happo off the floor--//
        if (this._happo.y > this._floorPosition.y - 50 && this._happo.dy > 0) {

            this._happo.dy = -this._happo.dy;
            this.justBounced = true;

            delay(()=> {
                this.justBounced = false;
            }, 0.15, this);

            if (!this.changedAnim && !this._happo.finalAnim) {
                this._happo.state.setAnimation(0, "flight" + Math.ceil(Math.random() * 9), true);
                this.changedAnim = true;
                delay(()=> {
                    this.changedAnim = false;
                }, 3, this);
            }

            //--bring happo back above the floor--//
            this._happo.y = this._floorPosition.y - 50.1;

            if (!this.noneSoundPlaying) {
                Common.audio.playSound(this.sounds["none"], {
                    onEnd: ()=> {
                        this.noneSoundPlaying = false;
                    }
                });
                this.noneSoundPlaying = true;
            }

            //this._dustEmitter.emit = false;
            //this._dustEmitter.cleanup();

            this._dustEmitter.emit = true;

            //--randomise rotation speed--//
            if (this._happo.dx >= 5) {
                this._happo.rotSpeed = (Math.random() - 0.5) * 0.2;
            }
        }

        //--if happo's velocity is zero then end the game--//
        if (this._happo.dx <= 0) {
            //console.log(this._happo.dy);
            //console.log(Math.round(this._happo.dy));
            if (Math.floor(this._happo.dy) <= 1 && Math.ceil(this._happo.dy) >= -1 && this._happo.y > 840) {
                this._running = false;
                this._camera.update = ()=> {
                };
                this._gameComplete = true;
                this.gameOver();
                return;
            }
        } else if (this._happo.dx < 60 && !this._happo.killRotate) {

            if (TweenMax.isTweening(this._happo)) {
                //console.log("had to kill tween on happo");
                TweenMax.killTweensOf(this._happo);
            }

            //console.log("killing rot");
            //console.log(this._happo.rotation);

            this._happo.killRotate = true;

            const targetRot = Math.round(this._happo.rotation / (Math.PI * 2)) * (Math.PI * 2);
            TweenMax.to(this._happo, 1, {
                rotation: targetRot, ease: Power0.easeNone, onComplete: ()=> {
                    //console.log("finished rotating happo to " + targetRot);
                }
            });
        } else if (this._happo.dx < 10) {
            this._happo.state.setAnimation(0, "hitground" + Math.ceil(Math.random() * 2) + "stop");
            this._happo.finalAnim = true;
        }

        if (this._happo.dy > 60) {
            this._happo.killRotate = false;
            this._happo.finalAnim = false;
        }

        if (this._happo.dy < 1 && this._happo.dy > -1 && this._happo.y > 840) {
            //console.log("forced dy to zero");
            this._happo.dy = 0;
        }

        //--remove some velocity to act as friction, this is removed over a short period of time then the flag
        //--is set to false and friction stops getting applied--//
        if (this.justBounced) {
            this._happo.dx -= 0.5;
            this._happo.dy += 2.5;
        }

        //--lock min x vel to be zero (dont go negative)--//
        if (this._happo.dx < 0) this._happo.dx = 0;

        //--update happo veloctiy and position--//
        this._happo.dy -= this._gravity;
        this._happo.x += this._happo.dx;
        this._happo.y += this._happo.dy;
        if (!this._happo.killRotate) this._happo.rotation += this._happo.rotSpeed;

        this.extraContainer.position.set(this._happo.x, this._happo.y);

        //--check for collision and set dx , dy for use next frame--//
        for (let i in this._objects) {

            if (this._objects[i].collided) continue;
            if (Common.collisionOBB(this._happo, this._objects[i], 0.9)) {

                const type = this._objects[i].type;
                const bounceFactor = this.bounceFactors[type];
                this._happo.dx += this._bouncePushForward;
                this._happo.dy = -bounceFactor * this._yBounceFactor;
                this._objects[i].collided = true;

                //--randomise rotation speed--//
                this._happo.rotSpeed = (Math.random() - 0.5) * 0.2;

                if (!this.changedAnim && !this._happo.finalAnim) {
                    this._happo.state.setAnimation(0, "flight" + Math.ceil(Math.random() * 9), true);
                    this.changedAnim = true;

                    delay(()=> {
                        this.changedAnim = false;
                    }, 3, this);
                }

                //--play the sound--//
                Common.audio.playSound(this.sounds[type]);

                TweenMax.to(this._objects[i].scale, 0.1, {
                    y: 0.7,
                    x: 1.25,
                    ease: Bounce.easeOut,
                    yoyo: true,
                    repeat: 1
                });

                //console.log("collide with obj " + type);

                break;
            }
        }
    }

    update() {

        for (let i in this._clouds) {
            this._clouds[i].x -= 0.05;//cloud drift
        }

        //--update particles--//
        for (let i = 0; i < this._particleEmitters.length; i++) {
            if (!this._particleEmitters[i]) continue;
            this._particleEmitters[i].update(deltaTime);
        }


        //     this.extraContainer.rotation = this._happo.rotation;

        this.pauseBtn.enabled = this._finishedIntro;
        this.pauseBtn.animate = this._finishedIntro;
        this.pauseBtn.visible = this._finishedIntro;

        this._dustEmitter.updateOwnerPos(this._happo.x, this._happo.y - 45);
        //  this._boostReadyEmitterHappo.updateOwnerPos(this._happo.x, this._happo.y - 45);

        if (!this._running || Common.paused || this._gameComplete) {
            return;
        }

        //--Tween.js update--//
        if (!this.useTweenMax) TWEEN.update();

        if (this._boostReadyEmitter.emit) {
            this._boostReadyEmitter.updateSpawnPos(this._happo.x + 25, this._happo.y);
            //this._boostReadyEmitter.rotate(Common.rad2deg(this._happo.rotation));
        }

        //--update parralax camera--//
        this._camera.update();

        const happoGlobal = this._happo.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));


        // ---- Collision detect stars ----
        for (let i = 0; i < this._stars.length; i++) {
            if (this._stars[i].collected || this._starsCollected >= 60) continue;
            if (Common.collisionOBB(this._happo, this._stars[i])) {

                this._starsCollected++;

                //==handle circular fill for star button==//

                const rad = 52;
                this._starBtnBack.removeChild(this._graphics);
                this._graphics.clear();
                this._graphics.destroy();
                this._graphics = new PIXI.Graphics();
                this._graphics.pivot.set(0.5);
                this._graphics.x = -rad * 0.5 - 4.5;
                // this._graphics.y = rad * 0.5 - 1;
                this._graphics.y = this._graphicsY;
                this._graphics.lineStyle(21, 0xffe011);

                this._currentFill = -Math.PI * 0.5 + ((2 * Math.PI) / 20) * this._starsCollected;

                if (this._starsCollected === 20) {
                    this._currentFill += 0.05;
                }

                this._graphics.arc(32, 57, rad, -Math.PI * 0.5, this._currentFill);
                this._starBtnBack.addChild(this._graphics, this._starBtnFront);


                //==end circle fill==//

                Common.audio.playSound("sfx_star_pickup_00");
                //  this._starsText.text = "" + this._starsCollected;
                //     if (this._starsCollected <= 20) this._fillMask.x += (150 / 20);
                let emitter = new PIXI.particles.Emitter(this._gameHolder, [Common.assets.getTexture("part_star")], this._starBurstConfig);
                emitter.updateOwnerPos(this._stars[i].x, this._stars[i].y);
                emitter.playOnceAndDestroy();
                this._particleEmitters.push(emitter);
                this._stars[i].collected = true;
                // this._stars[i].visible = false;
                //this._stars.splice(0, 1);
                if (this._starsCollected === 20 && Common.isFirstPlay) {
                    let str;
                    if (p3.Device.isMobile) str = "finger";
                    else str = "cursor";
                    this.starFinger.state.setAnimation(0, str + "_tap", true);
                    //this._happo.autoUpdate = false;
                    this._happo.state.timeScale = 0;
                    //TweenMax.pauseAll();
                    TweenMax.killTweensOf(this._happo);

                    this._running = false;
                    Common.isFirstPlay = false;
                    this.starFinger.visible = true;
                    this.starFinger.x = this._starBtnBack.x - this._starBtnBack.width * 0.5;
                    this.starFinger.y = this._starBtnBack.y;

                    this._uIntHolder.addChild(this.starFinger);
                }
                if (this._starsCollected >= 20 && !this._starParticles.emit) {
                    Common.audio.playSound("sfx_star_jump_ready_00");
                    //    this._happo.filters = this.glowFilter;
                    this._starParticles.emit = true;
                    //   this._boostReadyEmitter.emit = true;
                    //this._boostReadyEmitterHappo.emit = true;
                    this._starBtnFront.texture = Common.assets.getTexture("btn_boost_on");

                    this._starBtnBack.filters = this.glowFilter;

                    this._starTween = TweenMax.to(this._starBtnFront.scale, 0.5, {
                        x: 1.25,
                        y: 1.25,
                        yoyo: true,
                        repeat: -1,
                        ease: Power0.easeNone
                    });
                }

                this._stars[i].oldPos = new PIXI.Point(this._stars[i].x, this._stars[i].y);

                const localPos = this._stars[i].getGlobalPosition();
                localPos.x -= p3.View.width * 0.5;
                this._uIntHolder.addChild(this._stars[i]);
                this._stars[i].position.set(localPos.x, localPos.y);
                this._stars[i].scale.set(0.85);
                TweenMax.to(this._stars[i].scale, 0.5, {x: 0, y: 0, ease: Power0.easeNone});
                TweenMax.to(this._stars[i], 0.5, {x: this._starBtnBack.x, ease: Power0.easeNone});
                TweenMax.to(this._stars[i], 0.5, {
                    y: this._starBtnBack.y,
                    ease: Power1.easeOut,
                    onComplete: ()=> {
                        this._starBtnBack.scale.set(1);
                        TweenMax.from(this._starBtnBack.scale, 0.5, {x: 0.9, y: 0.9, ease: Bounce.bounceOut});
                        this._starBtnEmitter.emit = true;
                    }
                });

                break;
            }
        }

        // ---- Track distance ----
        if (this._launched) {
            this._totalDist = Math.round(Common.distance(this._startPos.x, 0, this._happo.x, 0) * 0.007);
            this._distanceText.text = "" + this._totalDist;
            if (this._happo.y < -550) {
                if (this._mapHolder.scale !== 0.5 && !TweenMax.isTweening(this._mapHolder)) {
                    TweenMax.to(this._mapHolder.scale, 0.5, {x: 0.5, y: 0.5, ease: Power0.easeNone});
                }
            } else {
                if (this._mapHolder.scale !== 0.75 && !TweenMax.isTweening(this._mapHolder)) {
                    TweenMax.to(this._mapHolder.scale, 0.25, {x: 0.75, y: 0.75, ease: Power0.easeNone});
                }
            }
        } else if (this._inputData) {
            const pos = this._inputData.getLocalPosition(this);
            if (!isNaN(pos.x)) {
                const minRot = this.minRotation, maxRot = -0.2;
                const rot = Common.angle(this._startPos.x - 500, this._startPos.y, pos.x, pos.y);
                if (Math.round(rot) !== Math.round(this._cannon.rotation)) Common.audio.playSound("sfx_cannon_move_0" + Math.round(Math.random() * 2));
                if (rot > minRot && rot < maxRot) {
                    this._cannon.rotation = rot;
                    this._cannonEmitter2.rotate(Common.rad2deg(rot));
                }
            }
        }

        //--update happo dx and dy--//
        if (this._launched) {
            this.updateHappo();
        }

        //--update camera track target--//
        this._trackTarg.x = this._happo.x;
        this._trackTarg.y = this._happo.y;// + 225;

        //--move alien with player--//
        this._alien.x = this._happo.x + this._alienOffset.x;

        //--update tile positions--//
        if (this.floorTiles.x < this._happo.x - this.floorTiles.width * 0.5) {
            this.floorTiles.x = this.floorTiles.x + this.floorTiles.width * 0.25;
        }


        if (this._happo.dx > 0) {

            let tilesGlobal = this.midTiles.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
            if (tilesGlobal.x < happoGlobal.x - this.tileSize * 3) {
                this.midTiles.x = this.midTiles.x + this.tileSize * 2;
                // console.log("moved mid tiles");
            }
            tilesGlobal = this.midBkTiles.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
            if (tilesGlobal.x < happoGlobal.x - this.tileSize * 3) {
                this.midBkTiles.x = this.midBkTiles.x + this.tileSize * 2;
                //  console.log("moved mid back tiles");
            }

            const mounts = this.mountainTiles;
            for (let i in mounts) {
                const sp = mounts[i];
                const spGlob = sp.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
                if (spGlob.x < happoGlobal.x - sp.width * 0.5) {
                    sp.x = mounts[mounts.length - 1].x + sp.width;
                    mounts.splice(i, 1);
                    mounts.push(sp);
                    //  console.log("moved mountains");
                    break;
                }
            }
        }


        for (let i in this._objects) {
            if (this._objects[i].x < this._happo.x - p3.View.width) {
                //resuse obj
                //this._objects[i].x += p3.View.width * 10;
                this._oldObjects.push(this._objects[i]);
                this._objects.splice(i, 1);
                if (this._objects.length === 0) {
                    this.repopulate();
                }
            }
        }

        for (let i in this._stars) {
            if (TweenMax.isTweening(this._stars[i])) continue;

            if (this._stars[i].x < this._happo.x - p3.View.width) {
                //resuse obj
                const star = this._stars[i];
                star.x = this._happo.x + i * 500 + (Math.random() * 75 - 75) + 1000;
                star.y = this._floorPosition.y - (Math.random() * 5000) - 75;
                //  this._stars[i].x += p3.View.width * 2;
                //  this._stars[i].y += Math.random() * 75 - 32.5;
                if (this._stars[i].y > this._floorPosition.y - 75) {
                    this._stars[i].y -= Math.random() * 100;
                }
                this._stars[i].collected = false;
                this._stars[i].visible = true;
                this._stars[i].scale.set(1);
                this._gameHolder.addChild(this._stars[i]);
            }
        }

        //repos deco elements to reuse the sprites
        let obj, globalPos;
        for (let i in this._decos) {
            obj = this._decos[i];
            globalPos = obj.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
            if (!(globalPos.x - happoGlobal.x < -p3.View.width - obj.width)) {
                obj.x = this._happo.x + Math.random() * p3.View.width * 2 + p3.View.width * 2;
            }
        }

        //repos deco elements to reuse the sprites
        for (let i in this._decosMG) {
            obj = this._decosMG[i];
            globalPos = obj.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
            if (globalPos.x - happoGlobal.x < -p3.View.width - obj.width) {
                obj.x = obj.x + Math.random() * p3.View.width * 10 + p3.View.width * 5;
            }
        }

        //repos deco elements to reuse the sprites
        for (let i in this._decosFG) {
            obj = this._decosFG[i];
            globalPos = obj.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
            if (globalPos.x - happoGlobal.x < -p3.View.width - obj.width) {
                obj.x = obj.x + Math.random() * p3.View.width * 5 + p3.View.width * 5;
            }
        }

        //repos deco elements to reuse the sprites
        for (let i in this._decosBG) {
            obj = this._decosBG[i];
            globalPos = obj.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
            if (globalPos.x - happoGlobal.x < -p3.View.width - obj.width) {
                obj.x = obj.x + Math.random() * p3.View.width * 5 + p3.View.width * 5;
            }
        }

        return;

        //--depth sort some stuff?--??
        this._bgHolder.children.sort(function (e, t) {
            return e.position.y > t.position.y ? 1 : e.position.y < t.position.y ? -1 : e.position.x > t.position.x ? 1 : e.position.x < t.position.x ? -1 : 0
        });
        this._midHolder.children.sort(function (e, t) {
            return e.position.y > t.position.y ? 1 : e.position.y < t.position.y ? -1 : e.position.x > t.position.x ? 1 : e.position.x < t.position.x ? -1 : 0
        });


        if (this.skidding) {
            this._dustEmitter.updateSpawnPos(this._happo.x, this._happo.y - 15);
            this._dustEmitter.emit = true;
        }


        //view culling
        for (let i in Common.displayObjs) {
            const sprite = Common.displayObjs[i];
            if (sprite.dead || !sprite || !sprite.transform) continue;
            // console.log(sprite);
            const globalCoordinates = sprite.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
            //const happoGlobal = this._happo.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
            sprite.renderable = !(globalCoordinates.x - happoGlobal.x < -p3.View.width - sprite.width * 5);
            //bit cheeky, basically if our sprite has gone off left edge of screen, set visible false so its transform isnt updated
            if (!sprite.renderable) {
                sprite.visible = false;
                this._gameHolder.addChild(sprite);//move to container
                this._gameHolder.removeChild(sprite);//remove from
                sprite.dead = true;
                //remove from arr
                // Common.displayObjs.splice(i, 1);
            }
            sprite.renderable = !(globalCoordinates.x - happoGlobal.x > p3.View.width + sprite.width * 5);
        }


    }

    jumpHappo() {
        const delayTime = 4;
        var jump = () => {
            const rand = Math.floor(Math.random() * this._happos.length);
            const happo = this._happos[rand];
            happo.tween.pause();
            TweenMax.to(happo, 0.25, {y: happo.y - 25, yoyo: true, repeat: 1});
            TweenMax.to(happo.scale, 0.25, {
                x: happo.scale.x - 0.05,
                y: happo.scale.y + 0.05,
                yoyo: true,
                repeat: 1,
                onComplete: ()=> {
                    happo.tween.resume();
                }
            });
        };
        delay(jump, delayTime, this);
    }

    start() {

        this.jumpHappo();

        let tempHappo = new PIXI.spine.Spine(Common.assets.getSpineData("stunt_happo_standing"));
        ///delay(()=> {
        ///     this._running = false
        //  }, 0.15, this);
        tempHappo.skeleton.setToSetupPose();
        tempHappo.autoUpdate = true;
        tempHappo.state.setAnimation(0, "run", true);
        tempHappo.scale.set(0.35);
        tempHappo.position.set(this._startPos.x, this._startPos.y/* - 75*/);
        tempHappo.y = p3.View.height * 1.5 - 225;
        tempHappo.x = -725;
        disp.push(tempHappo);
        this.starterHappo = tempHappo;
        this._gameHolder.addChild(tempHappo, this._cannon, this._canFront);//reorder
        TweenMax.to(tempHappo, 1, {
            x: this._cannon.x - 210,
            ease: Power0.easeNone,
            onComplete: ()=> {
                tempHappo.state.setAnimation(0, "wave");
                Common.audio.playSound("sfx_happo_ok_00");
                delay(()=> {
                    tempHappo.state.setAnimation(0, "run");
                    TweenMax.to(tempHappo, 0.5, {
                        x: tempHappo.x + 150,
                        ease: Power0.easeNone,
                        onComplete: ()=> {
                            //tempHappo.visible = false;
                            tempHappo.state.setAnimation(0, "idle");
                            tempHappo.x = 55;
                            tempHappo.y = 12;
                            tempHappo.scale.set(0.2);
                            this._cannon.addChild(tempHappo, this._cannonMainFront);
                            tempHappo.rotation = Common.deg2rad(75);
                            TweenMax.from(tempHappo, 0.5, {x: tempHappo.x - 45});
                            TweenMax.from(tempHappo.scale, 0.5, {
                                x: tempHappo.scale.x - 0.2,
                                y: tempHappo.scale.y - 0.2,
                                ease: Power1.easeOut
                            });
                        }
                    });


                    //Common.isFirstPlay = true;

                    //--client wants tutorial every time, hence why if true is true comparison--//
                    if (true) {

                        let finger = new PIXI.spine.Spine(Common.assets.getSpineData("tutorial"));
                        finger.skeleton.setToSetupPose();
                        finger.autoUpdate = true;
                        let str;
                        if (p3.Device.isMobile) str = "finger";
                        else str = "cursor";
                        finger.state.setAnimation(0, str + "_aim", true);
                        finger.scale.set(0.5);
                        finger.position.set(this._startPos.x + 350, this._startPos.y - 200);
                        this._particleHolder.addChild(finger);
                        finger.visible = false;
                        this.starFinger = finger;
                        //this.tutorialMovement = true;

                        delay(()=> {
                            if (!this._launched) {
                                //finger.visible = true;
                                this._cannon.tutLine.visible = true;
                                this._tutArrow.visible = true;
                                this._cannon.rotation = Common.deg2rad(-45);
                                this.tutTween = TweenMax.to(this._cannon, 0.9, {
                                    rotation: Common.deg2rad(-15),
                                    ease: Power0.easeNone,
                                    yoyo: true,
                                    repeat: 2,
                                    delay: 0.5,
                                    repeatDelay: 1,
                                    onComplete: ()=> {
                                        this._running = true;
                                        this._finishedIntro = true;
                                        //  this.tutorialMovement = false;
                                    },
                                    onRepeat: ()=> {
                                        this._tutArrow.scale.y *= -1;
                                    }
                                });

                            }
                        }, 1.5, this);
                        delay(()=> {
                            this._cannon.tutLine.visible = false;
                            this._tutArrow.visible = false;
                        }, 8, this);
                    } else {
                        this._running = true;
                        this._finishedIntro = true;
                    }
                }, 1, this);
            }
        });
    }

    end() {
        this._running = false;
        this.signals.next.dispatch(this);
    }

    /**
     * @deprecated
     */
    tweenAlien() {
        return;
        if (this._shownAlienThisGame) {
            this._alien.visible = false;
            return;
        }

        this._alien.visible = true;
        TweenMax.from(this._alien, 1.5, {
            x: -p3.View.width * 0.5,
            y: -p3.View.height * 0.5,
            ease: Power0.easeNone,
            onComplete: ()=> {
                TweenMax.to(this._alien, 1, {
                    y: this._alien.y + 250,
                    yoyo: true,
                    repeat: 3,
                    ease: Power0.easeNone,
                    onComplete: ()=> {
                        TweenMax.to(this._alien, 1.5, {
                            x: -p3.View.width * 0.5,
                            y: -p3.View.height * 0.5,
                            ease: Power0.easeNone,
                            onComplete: ()=> {
                                this._alien.position.set(this.alienStart.x, this.alienStart.y);
                                this._alien.visible = false;
                                this._shownAlienThisGame = true;
                            }
                        });
                    }
                });
            }
        });
    }

    /**
     * @deprecated
     */
    runCourse() {

        const logCourse = false;
        const useTweenMax = this.useTweenMax;
        const force3d = true;

        var bounceNext = ()=> {

            if (this._objects.length > 1) {

                const objIndex = this._objects.length - 1;
                const nextObj = this._objects[objIndex];

                let dist = nextObj.x - this._happo.x;
                let time = dist / this._speed;

                //this._speed -= 10;

                let yHei = this.lastObjHei - dist * this._bounceHeightFactor - 75;
                if (this.lastBounceWasBalloon) {
                    this.lastBounceWasBalloon = false;
                    if (logCourse) console.warn("balloon bounce");
                    yHei *= 1.5;
                    time *= 1.5;
                    if (nextObj.type !== "balloons") {
                        if (logCourse) console.log("last balloon in series");
                        time *= 1.25;
                    }
                } else {
                    if (nextObj.type === "balloons") {
                        if (logCourse) console.warn("super bounce to reach balloons");
                        yHei -= 1250;
                    }
                }

                if (this.lowLaunch) {
                    this.lowLaunch = undefined;
                    yHei += 350;
                    for (let i = 0; i < this._objects.length; i++) {
                        this._objects[i].x += 800;
                    }
                    for (let i = 0; i < this._stars.length; i++) {
                        this._stars[i].x += 800;
                    }
                } else if (this._justLaunched) {
                    this._justLaunched = false;
                    yHei += 150;
                }

                if (this.highLaunch) {
                    this.highLaunch = undefined;
                    this._happo.x -= 85;
                    this._happo.y -= 15;
                }

                if (yHei > this._happo.y) {
                    console.warn("target height is lower than the happo....");
                    yHei = this._happo.y - 650;
                }

                if (this._rotTween) this._rotTween.kill();
                this._rotTween = TweenMax.to(this._happo, time * this.backTimeFactor, {
                    rotation: Common.deg2rad(this.happoBackRotation),
                    ease: Power0.easeNone,
                    onComplete: ()=> {
                        this._rotTween = TweenMax.to(this._happo, time * this.forwardTimeFactor, {
                            rotation: Common.deg2rad(this.happoForwardRotation),
                            ease: Power0.easeNone
                        });
                    }
                });

                if (!useTweenMax) {
                    this._horTween = new TWEEN.Tween(this._happo) // Create a new tween that modifies 'coords'.
                        .to({x: nextObj.x}, time * 1000) // Move to (300, 200) in 1 second.
                        .easing(TWEEN.Easing.Linear.None) // Use an easing function to make the animation smooth.
                        .start(); // Start the tween immediately.
                    this._upTween = new TWEEN.Tween(this._happo) // Create a new tween that modifies 'coords'.
                        .to({y: yHei}, time / 2 * 1000) // Move to (300, 200) in 1 second.
                        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
                        .start(); // Start the tween immediately.

                    this._downTween = new TWEEN.Tween(this._happo) // Create a new tween that modifies 'coords'.
                        .to({y: nextObj.y - nextObj.height}, time / 2 * 1000) // Move to (300, 200) in 1 second.
                        .easing(TWEEN.Easing.Quadratic.In);// Use an easing function to make the animation smooth.

                    this._upTween.onComplete(()=> {
                        this._downTween.start();
                        if (this.relaunched) {
                            this.relaunched = false;
                            this._happo.scale.set(0.35);
                            const myString = "flight" + Math.ceil(Math.random() * 9);
                            this._happo.state.setAnimation(0, myString, true);
                        }
                    });

                    this._downTween.onComplete(()=> {
                        if (nextObj.type !== "pit") {
                            TweenMax.to(obj.scale, 0.1, {
                                y: 0.7,
                                x: 1.25,
                                ease: Bounce.easeOut,
                                yoyo: true,
                                repeat: 1
                            });
                        }

                        if (nextObj.type !== "pit") {
                            Common.audio.playSound(this.sounds[this._objects[0].type]);
                            if (nextObj.type === "none") {
                                this._dustEmitter.emit = false;
                                this._dustEmitter.cleanup();
                                this._dustEmitter.updateSpawnPos(this._happo.x, this._happo.y - 45);
                                delay(()=> {
                                    this._dustEmitter.emit = true;
                                }, 0.1, this);
                            }
                        } else {
                            if (nextObj.particle === "water") {
                                this._waterEmitter.updateSpawnPos(this._happo.x, this._happo.y);
                                this._waterEmitter.emit = true;
                                Common.audio.playSound("sfx_bounce_puddle_00");
                            } else {
                                this._mudEmitter.updateSpawnPos(this._happo.x, this._happo.y);
                                this._mudEmitter.emit = true;
                                Common.audio.playSound("sfx_bounce_mud_00");
                            }
                        }
                        if (nextObj.type === "balloons") {
                            this.lastBounceWasBalloon = true;
                        }
                        this.lastObjHei = nextObj.y;

                        this._oldObjects.push(this._objects[objIndex]);

                        this._objects.pop();
                        this._speed *= 0.85;
                        if (this._speed < this._speedMin) this._speed = this._speedMin;
                        const myString = "flight" + Math.ceil(Math.random() * 9);
                        this._happo.state.setAnimation(0, myString, true);
                        this._happo.scale.set(0.35);
                        bounceNext();
                    });
                } else {
                    this._horTween = TweenMax.to(this._happo, time, {
                        x: nextObj.x,
                        ease: Power0.easeNone,
                        autoKill: true,
                        force3D: force3d
                    });
                    this._upTween = TweenMax.to(this._happo, time * 0.5, {
                        y: yHei,
                        ease: Power1.easeOut,
                        onComplete: ()=> {
                            if (this.relaunched) {
                                this.relaunched = false;
                                this._happo.scale.set(0.35);
                                const myString = "flight" + Math.ceil(Math.random() * 9);
                                this._happo.state.setAnimation(0, myString, true);
                            }
                        },
                        force3D: force3d
                    });
                    this._downTween = TweenMax.to(this._happo, time * 0.5, {
                        y: this._objects[objIndex].y - this._objects[objIndex].height,
                        ease: Power1.easeIn,
                        delay: time * 0.5,
                        force3D: force3d,
                        onComplete: ()=> {
                            const obj = this._objects[objIndex];
                            if (obj.type !== "pit") {
                                TweenMax.to(obj.scale, 0.1, {
                                    y: 0.7,
                                    x: 1.25,
                                    ease: Bounce.easeOut,
                                    yoyo: true,
                                    repeat: 1
                                });
                            }

                            if (this._objects[objIndex].type !== "pit") {
                                Common.audio.playSound(this.sounds[this._objects[objIndex].type]);
                                if (this._objects[objIndex].type === "none") {
                                    this._dustEmitter.emit = false;
                                    this._dustEmitter.updateSpawnPos(this._happo.x, this._happo.y - 45);
                                    delay(()=> {
                                        this._dustEmitter.emit = true;
                                    }, 0.1, this);
                                }
                            } else {
                                if (this._objects[objIndex].particle === "water") {
                                    this._waterEmitter.updateSpawnPos(this._happo.x, this._happo.y);
                                    this._waterEmitter.emit = true;
                                    Common.audio.playSound("sfx_bounce_puddle_00");
                                } else {
                                    this._mudEmitter.updateSpawnPos(this._happo.x, this._happo.y);
                                    this._mudEmitter.emit = true;
                                    Common.audio.playSound("sfx_bounce_mud_00");
                                }
                            }
                            if (this._objects[objIndex].type === "balloons") {
                                this.lastBounceWasBalloon = true;
                            }
                            this.lastObjHei = this._objects[objIndex].y;

                            this._oldObjects.push(this._objects[objIndex]);

                            this._objects.pop();
                            this._speed *= 0.85;
                            if (this._speed < this._speedMin) this._speed = this._speedMin;
                            const myString = "flight" + Math.ceil(Math.random() * 9);
                            this._happo.state.setAnimation(0, myString, true);
                            this._happo.scale.set(0.35);
                            bounceNext();
                        }
                    });
                }
            } else {
                this._happo.rotation = 0;
                this.skid();
            }
        };
        bounceNext();
    }

    /**
     * @deprecated
     * Do skid ending animation and game ending
     */
    skid() {
        TweenMax.killTweensOf(this._happo);

        this.skidding = true;
        this._happo.rotation = 0;

        let count = 0;
        const maxBounces = 4;
        let dist = 1200;

        var tweener = () => {

            const time = dist / this._speed;

            if (count === maxBounces * 0.5) {
                if (Math.random() < 0.5) {
                    this.skidding = false;
                    //do puddle ending
                    const puddleDist = 1600;
                    const yHei = puddleDist * this._bounceHeightFactor;

                    let str = "", isMud = false;
                    if (Math.random() < 0.5) {
                        str = "pond_" + Math.ceil(Math.random() * 2);
                    } else {
                        str = "puddle_" + Math.ceil(Math.random() * 2);
                        isMud = true;
                    }

                    const puddle = createSprite(str, this._gameHolder);
                    puddle.position.set(this._happo.x + puddleDist, this._floorPosition.y - 65);
                    const time2 = puddleDist / this._speed;

                    this._gameHolder.addChild(this._happo);

                    //hor
                    TweenMax.to(this._happo, time2, {x: puddle.x, ease: Power0.easeNone});
                    //up
                    TweenMax.to(this._happo, time2 * 0.5, {y: yHei, ease: Power1.easeOut});
                    //down
                    TweenMax.to(this._happo, time2 * 0.5, {
                        y: puddle.y + 35,
                        ease: Power1.easeIn,
                        delay: time2 * 0.5,
                        onComplete: ()=> {
                            if (!isMud) {
                                this._waterEmitter.updateSpawnPos(this._happo.x, this._happo.y);
                                this._waterEmitter.emit = true;
                                Common.audio.playSound("sfx_bounce_puddle_00");
                            } else {
                                this._mudEmitter.updateSpawnPos(this._happo.x, this._happo.y);
                                this._mudEmitter.emit = true;
                                Common.audio.playSound("sfx_bounce_mud_00");
                            }

                            this._gameComplete = true;
                            this._happo.visible = false;
                            //cheeky overide
                            this._camera.update = ()=> {
                            };
                            this.gameOver();

                        }
                    });
                    return;
                }
            }

            if (count < maxBounces) {
                //--horizontal tween--//
                TweenMax.to(this._happo, time, {x: this._happo.x + dist, ease: Power0.easeNone});

                //--vertical tween--//
                TweenMax.to(this._happo, time * 0.5, {y: this._happo.y - dist * 0.25, ease: Power1.easeOut});
                TweenMax.to(this._happo, time * 0.5, {
                    y: this._floorPosition.y,
                    ease: Power1.easeIn,
                    delay: time * 0.5,
                    onComplete: ()=> {
                        count++;
                        dist *= 0.75;
                        tweener();
                    }
                });
            } else {
                //--horizontal tween--//
                TweenMax.to(this._happo, time * 10, {
                    x: this._happo.x + dist * 10,
                    ease: Power0.easeNone,
                    onComplete: ()=> {
                        this._gameComplete = true;
                        this._happo.state.setAnimation(0, "hitground" + Math.ceil(Math.random() * 2) + "stop");
                        this.skidding = false;
                        //cheeky overide
                        this._camera.update = ()=> {
                        };
                        this.gameOver();
                    }
                });
            }
        };
        tweener();
    }

    initWorld() {
        this.initObjects();
        this.initCamera();
        this.initParticles();
    }

    initCamera() {
        this._camera = new p3.Camera(new PIXI.Point(0, p3.View.height * 0.5), false);
        this._camera.trackEase = this.maxCamEase;
        this._camera.y = this._camera.view.y;
        this._camera.bounds.height = (p3.View.height - this._camera.view.y + 200) * 0.75 - 75;
        Common.camera = this._camera;

        this._camera.addLayer("bg", this._bgHolder, new PIXI.Point(0.05, 1));
        this._camera.addLayer("fg", this._fgHolder, new PIXI.Point(0.9, 1));

        this._camera.addLayer("game", this._gameHolder, new PIXI.Point(0.7, 1));
        this._camera.addLayer("gamePart", this._particleHolder, new PIXI.Point(0.7, 1));
        this._camera.addLayer("mid", this._midHolder, new PIXI.Point(0.5, 1));
        this._camera.addLayer("midBk", this._midBackHolder, new PIXI.Point(0.4, 1));

        this._camera.trackTarget({x: this._startPos.x + 250, y: this._startPos.y}, true);
    }

    addStars() {

        for (let i = 1; i < this._objects.length; i++) {

            // const rand = Math.random();
            //  console.log(rand + " : " + this.starChance + " : " + (this.starChance < rand));


            if (this._objects[i].type === "pit") continue;
            if (this._objects[i - 1] && (this._objects[i - 1].type === "balloons" || this._objects[i - 1].type === "pit")) continue;

            if (this._objects[i].type === "balloons") {
                //jump apex
                let star = createSprite("star", this._gameHolder);
                star.x = this._objects[i].x;
                let dist = this._objects[i].x - this._objects[i - 1].x;
                star.x -= dist * 0.5;
                star.y = this._objects[i].y - (dist * this._bounceHeightFactor - 75) * 1.5;
                if (star.y > this._floorPosition.y - 50) {
                    star.visible = false;
                    star.collected = true;
                }
                this._stars.push(star);

                //mid way up
                star = createSprite("star", this._gameHolder);
                star.x = this._objects[i].x;
                star.x -= dist * 0.75;
                star.y = this._objects[i].y - (dist * this._bounceHeightFactor * 0.8 - 75) * 1.5;

                if (star.y > this._floorPosition.y - 50) {
                    star.visible = false;
                    star.collected = true;
                }
                this._stars.push(star);

                //mid way down
                star = createSprite("star", this._gameHolder);
                star.x = this._objects[i].x;
                star.x -= dist * 0.25;
                star.y = this._objects[i].y - (dist * this._bounceHeightFactor * 0.8 - 25) * 1.5;

                if (star.y > this._floorPosition.y - 50) {
                    star.visible = false;
                    star.collected = true;
                }
                this._stars.push(star);
            } else if (Math.random() < this.starChance) {
                //jump apex
                let star = createSprite("star", this._gameHolder);
                star.x = this._objects[i].x;
                let dist = this._objects[i].x - this._objects[i - 1].x;
                star.x -= dist * 0.5;
                star.y = this._objects[i].y - dist * this._bounceHeightFactor - 50;
                if (star.y > this._floorPosition.y - 50) {
                    star.visible = false;
                    star.collected = true;
                }
                this._stars.push(star);

                //mid way up
                star = createSprite("star", this._gameHolder);
                star.x = this._objects[i].x;
                star.x -= dist * 0.75;
                star.y = this._objects[i].y - dist * this._bounceHeightFactor * 0.8 - 75;

                if (star.y > this._floorPosition.y - 50) {
                    star.visible = false;
                    star.collected = true;
                }
                this._stars.push(star);

                //mid way down
                star = createSprite("star", this._gameHolder);
                star.x = this._objects[i].x;
                star.x -= dist * 0.25;
                star.y = this._objects[i].y - dist * this._bounceHeightFactor * 0.8 - 75;

                if (star.y > this._floorPosition.y - 50) {
                    star.visible = false;
                    star.collected = true;
                }
                this._stars.push(star);
            }
        }
    }

    initObjects() {

        //--binds--//
        addDeco = addDeco.bind(this);
        addObstacles = addObstacles.bind(this);
        addBg = addBg.bind(this);

        addDeco();
        // addObstacles();
        addBg();

        const banner = createSprite("banner_start", this._gameHolder);
        banner.y = p3.View.height * 0.5 + 25;
        banner.x = -325;

        let txt;
        if (Common.language === "ar" || Common.language === "ru" || Common.language === "tr") {
            txt = p3.simpleText(Common.copy.start[Common.language], "arial", 120, null, 0xd21402);
        } else {
            txt = new PIXI.extras.BitmapText(Common.copy.start[Common.language], {
                font: "95px Ziclets",
                align: "center",
                tint: 0xd21402
            });
        }

        txt.anchor.set(0.5);
        txt.x = -90;
        txt.y = 110;
        txt.skew.y = Common.deg2rad(2);
        txt.scale.x = 0.45;
        txt.rotation = Common.deg2rad(4);
        banner.addChild(txt);

        if (Common.language !== "en") {
            txt.scale.set(0.25);
            txt.y += 25;
            txt.x -= 5;
            txt.rotation = Common.deg2rad(6);
        }

        const cannonBk = createSprite("cannon_back", this._gameHolder);
        const cannonMain = createSprite("cannon_main", this._gameHolder);
        const cannonMainFront = createSprite("cannon_main_2", cannonMain);
        const cannonFront = createSprite("cannon_front", this._gameHolder);
        cannonBk.position.set(this._startPos.x - 130, this._startPos.y - 75);
        cannonMain.position.set(this._startPos.x - 175, this._startPos.y + 25);
        cannonFront.position.set(this._startPos.x - 130, this._startPos.y - 75);
        cannonBk.scale.set(1.5);
        cannonMain.scale.set(1.5);
        cannonFront.scale.set(1.5);

        const dotLine = createSprite("dotted_line", cannonMain);
        dotLine.anchor.set(0, 0.5);
        dotLine.visible = false;
        dotLine.position.set(75, 0);
        cannonMain.tutLine = dotLine;

        const finger = createSprite("hand_big", dotLine);
        finger.anchor.set(0, 0.5);
        finger.scale.set(0.75);
        finger.x = dotLine.width;
        finger.y = finger.height * 0.5;

        const dirArrow = createSprite("tutorial_arrow", this._gameHolder);
        dirArrow.anchor.set(0.5);
        dirArrow.y = p3.View.height - 75;
        dirArrow.x = p3.View.width * 0.5 + 125;
        dirArrow.scale.y = -1;
        dirArrow.visible = false;
        this._tutArrow = dirArrow;

        //--add in the alien--//
        this._alien = new PIXI.spine.Spine(Common.assets.getSpineData("alien"));
        this._alien.skeleton.setToSetupPose();
        this._alien.autoUpdate = true;
        this._alien.state.setAnimation(0, "idle_0", true);
        this._alien.y = -1550;
        this._alien.x = 125;
        this._alien.scale.set(0.5);

        this._gameHolder.addChild(this._alien);

        disp.push(this._alien);

        //give alien a lil animation on y
        //TweenMax.to(this._alien, 3, {y: this._alien.y + 250, yoyo: true, repeat: -1, ease: Power0.easeNone});
        //tween his x offset too
        //TweenMax.to(this._alienOffset, 3, {x: 150, yoyo: true, repeat: -1, ease: Power0.easeNone});

        this._happo = new PIXI.spine.Spine(Common.assets.getSpineData("stunt_happo_flying"));
        this._happo.skeleton.setToSetupPose();
        this._happo.autoUpdate = true;
        this._happo.state.setAnimation(0, "flight" + Math.ceil(Math.random() * 9), true);
        this._happo.scale.set(0.35);
        this._happo.position.set(this._startPos.x, this._startPos.y/* - 75*/);
        this._happo.visible = false;
        this._gameHolder.addChild(this._happo);
        this._cannon = cannonMain;
        this._cannonMainFront = cannonMainFront;
        this._canFront = cannonFront;
        cannonMain.anchor.set(0.4, 0.5);
        cannonMainFront.anchor.set(0.4, 0.5);

        this._happo.state.data.defaultMix = 0.5;
        this._happo.killRotate = false;
        this._happo.finalAnim = false;

        //set the animation mix duration default
        // this._view.state.data.defaultMix = 0.25;

        //setup happos velocities
        this._happo.dx = 0;
        this._happo.dy = 0;
        this._happo.rotSpeed = 0;

        //setup flow filtert
        this.glowFilter = [new PIXI.filters.GlowFilter(10, 0, 0, 0xffffff, 0.25)];
        // console.log(this.glowFilter[0].uniforms);
        TweenMax.to(this.glowFilter[0].uniforms, 0.5, {
            outerStrength: 4,
            yoyo: true,
            repeat: -1,
            ease: Power0.easeNone
        });
        // this._cannon.filters = this.glowFilter;
        disp.push(this._happo);

        //animate start
        TweenMax.to(cannonMain, 3, {rotation: Common.deg2rad(-30), ease: Elastic.easeOut, delay: 0.5});

        function addObstacles() {
            //--min and max distance between obstacles and total obs--//
            const numObstacles = this.basicLength + Math.round(Math.random() * this.randomLength);
            let slowDown = 1;
            let distFromStart = 0, obs, rand;
            for (let i = 0; i < numObstacles; i++) {
                if (i > 2) {
                    if (i < numObstacles - 4) {

                        const lastType = this._objects[this._objects.length - 1].type;

                        if (lastType !== "balloons") {

                            if (lastType === "trampoline" ||
                                lastType === "spring" ||
                                lastType === "spring_2" ||
                                lastType === "float") {

                                obs = createSprite("balloons", this._gameHolder);
                                obs.type = "balloons";
                                slowDown = 1;

                            } else {
                                rand = Math.floor(Math.random() * (Object.keys(this.objTextures).length + this.chanceNoneObs));
                                if (rand < Object.keys(this.objTextures).length) {
                                    rand = Math.floor(Math.random() * (Object.keys(this.objTextures).length));
                                    obs = createSprite(this.objTextures[rand], this._gameHolder);
                                    obs.type = this.objTextures[rand];
                                    slowDown = 1;
                                } else {
                                    obs = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
                                    obs.type = "none";
                                    obs.height = 45;
                                }
                            }

                        } else if (Math.random() < 0.5) {
                            obs = createSprite("balloons", this._gameHolder);
                            obs.type = "balloons";
                            slowDown = 1;
                        } else {
                            obs = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
                            obs.type = "none";
                            obs.height = 45;
                        }
                    } else {
                        obs = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
                        obs.type = "none";
                        obs.height = 45;
                    }
                } else {
                    obs = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
                    obs.type = "none";
                    obs.height = 45;
                }

                //console.warn(this._objects[i - 1].type);
                if (i > 0) {
                    const dist = (this.bounceFactors[this._objects[this._objects.length - 1].type] * 100 + Math.round(Math.random() * this.randomObsDist)) * slowDown;
                    distFromStart += dist;
                    if (slowDown > 0.2) {
                        slowDown -= 0.25;
                    } else {
                        //end of run
                        return;
                    }
                    if (Math.random() < 0.25) {
                        rand = Math.floor(Math.random() * (Object.keys(this.objTextures).length));
                        const dummyObj = createSprite(this.objTextures[rand], this._gameHolder);
                        dummyObj.position.set(distFromStart - 125 + Math.random() * 200, this._floorPosition.y + 50);
                        dummyObj.anchor.set(0.5, 1);
                    }
                }
                obs.anchor.set(0.5, 1);
                obs.position.set(distFromStart, this._floorPosition.y + 50);
                if (obs.type === "balloons") {
                    obs.y = Math.random() * -350 - 150;
                }
                obs.visible = false;
                this._objects.push(obs);
            }
        }

        function addDeco() {

            let floor = new PIXI.extras.TilingSprite(Common.assets.getTexture("ground"), this.tileSize * 8, 550 / 2);
            floor.position.x = -p3.View.width;
            floor.position.y = p3.View.height - 75;
            floor.uvTransform.clampMargin = 0;
            floor.uvTransform.clampOffset = -1;
            floor.scale.y = 1.5;
            //  floor.visible = false;

            const mounts = [];
            for (let i = 0; i < 5; i++) {
                const sp = createSprite("mountains_2_bg", this._bgHolder);
                sp.scale.set(2);
                sp.x = -sp.width + i * sp.width;
                sp.y = p3.View.height * 0.5 - 400;
                mounts.push(sp);
            }

            let mid = new PIXI.extras.TilingSprite(Common.assets.getTexture("mid_ground"), this.tileSize * 6, 500 / 2);
            mid.position.x = -p3.View.width;
            mid.position.y = p3.View.height - 115;
            mid.uvTransform.clampMargin = 0;
            mid.uvTransform.clampOffset = -1;
            // mid.visible = false;

            let midBk = new PIXI.extras.TilingSprite(Common.assets.getTexture("mid_ground_2"), this.tileSize * 6, 102);
            midBk.position.x = -p3.View.width;
            midBk.position.y = p3.View.height - 180;
            midBk.uvTransform.clampMargin = 0;
            midBk.uvTransform.clampOffset = -1;
            //  midBk.visible = false;

            disp.push(floor, mid, midBk);

            this.floorTiles = floor;
            this.mountainTiles = mounts;
            this.midTiles = mid;
            this.midBkTiles = midBk;

            this._gameHolder.addChild(floor);

            this._midHolder.addChild(mid);
            this._midBackHolder.addChild(midBk);

            this._decos = [];
            this._decosMG = [];
            this._decosFG = [];
            this._decosBG = [];

            let obj;
            for (let i = 0; i < 2; i++) {
                let rand = Math.round(Math.random() + 1);
                obj = createSprite("rock_" + rand, this._bgHolder);
                obj.x = i * 2000 + Math.random() * 1000;
                obj.y = (p3.View.height * 0.5) + Math.round(Math.random() * 75) + 75;
                obj.y += Math.random() * 50;
                obj.scale.set((Math.random() * 0.1) + 0.5);
                this._decosBG.push(obj);
            }

            for (let i = 0; i < 2; i++) {
                obj = createSprite("bush_midground", this._bgHolder);
                obj.x = i * 2000 + Math.random() * 1000;
                obj.y = (p3.View.height * 0.5) + Math.round(Math.random() * 75) + 75;
                obj.y += Math.random() * 50;
                obj.scale.set((Math.random() * 0.1) + 0.5);
                this._decosBG.push(obj);
            }

            for (let i = 0; i < 2; i++) {
                obj = createSprite("tree_midground", this._bgHolder);
                obj.x = i * 2000 + Math.random() * 1000;
                obj.y = (p3.View.height * 0.5) + Math.round(Math.random() * 75) + 75;
                obj.y -= Math.random() * 50;
                obj.scale.set((Math.random() * 0.1) + 0.5);
                this._decosBG.push(obj);
            }

            for (let i = 0; i < 1; i++) {
                obj = createSprite("rock_fg", this._fgHolder);
                obj.anchor.y = 1;
                obj.x = i * 2000 + Math.random() * 1000;
                obj.y = p3.View.height + obj.height;
                obj.scale.set((Math.random() * 0.25) + 0.75);
                obj.fg = true;
                this._decosFG.push(obj);
            }
            for (let i = 0; i < 1; i++) {
                let rand = Math.round(Math.random() + 1);
                obj = createSprite("rock_" + rand, this._midHolder);
                obj.x = i * 2000 + Math.random() * 1000;
                obj.y = (p3.View.height * 0.5) + Math.round(Math.random() * 75) + 200;
                obj.scale.set((Math.random() * 0.25) + 0.75);
                this._decosMG.push(obj);
            }
            let midDisp = [];
            for (let i = 0; i < 1; i++) {
                obj = createSprite("tree_midground", this._midBackHolder);
                obj.x = i * 2000 + Math.random() * 1000;
                obj.y = (p3.View.height * 0.5) + 315;
                //obj.scale.set((Math.random() * 0.25) + 0.75);
                obj.anchor.set(0.5, 1);
                obj.scale.set(2);
                midDisp.push(obj);
                this._decosMG.push(obj);
            }
            for (let i = 0; i < 1; i++) {
                obj = createSprite("bush_midground", this._midBackHolder);
                obj.x = i * 2000 + Math.random() * 1000;
                obj.y = (p3.View.height * 0.5) + 150;
                //obj.scale.set((Math.random() * 0.25) + 0.75);
                midDisp.push(obj);
                this._decosMG.push(obj);
            }

            //randomises draw order
            midDisp = Common.shuffleArr(midDisp);
            for (let i = 0; i < midDisp.length; i++) {
                this._midBackHolder.addChild(midDisp[i]);
            }

            //--add in clouds--//
            for (let i = 0; i < 8; i++) {
                obj = createSprite("cloud_b_" + Math.ceil(Math.random() * 3), this._bgHolder);
                obj.x = i * 2000 + Math.random() * 1000;
                obj.y = (p3.View.height * 0.5) - 650 - Math.random() * 100;
                //obj.scale.set((Math.random() * 0.25) + 0.75);
                obj.scale.set((Math.random() * 0.25) + 1);
                this._clouds.push(obj);
                midDisp.push(obj);
                this._decosBG.push(obj);
            }

            //--add in clouds--//
            for (let i = 0; i < 8; i++) {
                obj = createSprite("cloud_m_" + Math.ceil(Math.random() * 3), this._bgHolder);
                obj.x = i * 2000 + Math.random() * 1000;
                obj.y = (p3.View.height * 0.5) - 100 - Math.random() * 200;
                //obj.scale.set((Math.random() * 0.25) + 0.75);
                obj.scale.set((Math.random() * 0.25) + 0.75);
                this._clouds.push(obj);
                midDisp.push(obj);
                this._decosBG.push(obj);
            }

            //--add in clouds high--//
            for (let i = 0; i < 8; i++) {
                obj = createSprite("cloud_b_" + Math.ceil(Math.random() * 3), this._bgHolder);
                obj.x = i * 1000 - Math.random() * 1000;
                obj.y = (p3.View.height * 0.5) - 1000;
                obj.scale.set((Math.random() * 1.75) + 0.75);
                this._clouds.push(obj);
                midDisp.push(obj);
                this._decosBG.push(obj);
            }

            //--add in clouds high--//
            for (let i = 0; i < 8; i++) {
                obj = createSprite("cloud_m_" + Math.ceil(Math.random() * 3), this._bgHolder);
                obj.x = i * 2000 - Math.random() * 1000;
                obj.y = (p3.View.height * 0.5) - 2000;
                obj.scale.set((Math.random() * 1.75) + 0.75);
                this._clouds.push(obj);
                midDisp.push(obj);
                this._decosBG.push(obj);
            }

            //--add in clouds high--//
            for (let i = 0; i < 8; i++) {
                obj = createSprite("cloud_m_" + Math.ceil(Math.random() * 3), this._bgHolder);
                obj.x = i * 2000 - Math.random() * 1000;
                obj.y = (p3.View.height * 0.5) - 2500 - Math.random() * 1000;
                obj.scale.set((Math.random() * 1.75) + 0.75);
                this._clouds.push(obj);
                midDisp.push(obj);
                this._decosBG.push(obj);
            }

            //--add in clouds high--//
            for (let i = 0; i < 8; i++) {
                obj = createSprite("cloud_b_" + Math.ceil(Math.random() * 3), this._bgHolder);
                obj.x = i * 250 + Math.random() * 250;
                obj.y = (p3.View.height * 0.5) - 3000 - Math.random() * 2000;
                obj.scale.set((Math.random() * 1.75) + 0.75);
                this._clouds.push(obj);
                midDisp.push(obj);
                this._decosBG.push(obj);
            }

            //--add in clouds high--//
            for (let i = 0; i < 8; i++) {
                obj = createSprite("cloud_m_" + Math.ceil(Math.random() * 3), this._bgHolder);
                obj.x = i * 250 + Math.random() * 250;
                obj.y = (p3.View.height * 0.5) - 3000 - Math.random() * 500;
                obj.scale.set((Math.random() * 1.75) + 0.75);
                this._clouds.push(obj);
                midDisp.push(obj);
                this._decosBG.push(obj);
            }

            //--add in clouds front--//
            for (let i = 0; i < 8; i++) {
                obj = createSprite("cloud_b_" + Math.ceil(Math.random() * 3), this._gameHolder);
                obj.x = i * 250 + Math.random() * 250;
                obj.y = (p3.View.height * 0.5) - 1200 + Math.random() * 350;
                obj.scale.set((Math.random() * 2.75) + 1.75);
                obj.alpha = 0.5;
                midDisp.push(obj);
                this._decos.push(obj);
            }

            //--add in clouds front--//
            for (let i = 0; i < 8; i++) {
                obj = createSprite("cloud_m_" + Math.ceil(Math.random() * 3), this._fgHolder);
                obj.x = i * 250 + Math.random() * 250;
                obj.y = (p3.View.height * 0.5) - 1200 + Math.random() * 350;
                obj.scale.set((Math.random() * 2.75) + 1.75);
                obj.alpha = 0.5;
                midDisp.push(obj);
                this._decosFG.push(obj);
                obj.fg = true;
            }

            //--add happos--//
            for (let i = 0; i < 10; i++) {
                obj = this.createHappo();
                obj.x = i * 10000 + 125;
                obj.shadow.position.set(obj.x, obj.y - 30);
                if (obj.type === "ballerina") obj.shadow.y -= 10;
                else if (obj.type === "worker") obj.shadow.y -= 5;
            }
        }

        function addBg() {
            //uses a tiling sprite for background
            let bgTiles = createSprite("sky");
            Common.displayObjs.pop();//remove sky from culling array because it is moved with the player

            bgTiles.width = p3.View.width * 2;
            bgTiles.height = p3.View.height * 2.5;
            bgTiles.y -= 20;

            bgTiles.interactive = true;
            bgTiles.hitArea = new PIXI.Rectangle(0, 0, p3.View.width, p3.View.height);
            bgTiles.mousedown = bgTiles.touchstart = this.inputDown.bind(this);
            bgTiles.mouseup = bgTiles.mouseupoutside = bgTiles.touchend = bgTiles.touchendoutside = ()=> {

                if (this._launched || Common.paused || this.justUnpaused || !this._running || this.skidding || this._gameComplete || !this._inputData) return;

                Common.audio.playSound("sfx_happo_fling_0" + Math.round(Math.random()));
                Common.audio.playSound("sfx_cannon_fire_0" + Math.round(Math.random()));

                this.starterHappo.visible = false;
                this._starBtnBack.visible = true;

                this._cannonEmitter.emit = true;
                this._cannonEmitter2.emit = true;

                const rotation = this._cannon.rotation;
                // if (rotation > -0.3) this.lowLaunch = true;
                if (rotation < -0.7) {
                    this._happo.x -= 85;
                    this._happo.y -= 25;
                }

                const mousePos = this._inputData.getLocalPosition(this);
                const length = Common.distance(this._happo.x, this._happo.y, mousePos.x, mousePos.y);

                TweenMax.from(this._happo.scale, 0.25, {x: 0.15, y: 0.15, ease: Power1.easeOut});
                this._happo.rotation = rotation;

                // for (let i = 0; i < this._objects.length; i++) {
                //  this._objects[i].x += Math.abs(rotation * 6000);
                //   this._objects[i].visible = true;
                //   }
                // this.addStars();
                // this._objects.reverse();
                this._happo.visible = true;
                this._inputData = null;
                this._cannon.rotation = rotation;
                this._launched = true;
                //  this.runCourse();
                delay(()=> {
                    this._camera.trackTarget(this._trackTarg);
                    this._camera.trackEase = 0.01;
                    TweenMax.to(this._camera, 0.5, {
                        trackEase: this.maxCamEase,
                        ease: Power0.easeNone
                    });

                }, 0.25);


                //--calculate happos dx , dy--//
                const dx = Math.cos(rotation) * length;
                const dy = Math.sin(rotation) * length;

                // console.log(dx);
                // console.log(dy);

                this._happo.dx = dx / 10;
                this._happo.dy = dy / 10;

                this._gameHolder.addChild(this._cannon);

            };
            this._back.addChild(bgTiles);
            this._sky = bgTiles;
        }
    }

    inputDown(event) {

        if (Common.paused || this.justUnpaused || this._gameComplete) return;

        if (this._cannon.tutLine.visible) {
            this._happo.state.timeScale = 1;
            TweenMax.resumeAll();
            Common.paused = false;
            this.starFinger.visible = false;
            this._cannon.tutLine.visible = false;
            this._tutArrow.visible = false;
            this._running = true;
            if (this.tutTween) {
                this.tutTween.kill();
            }
            this._finishedIntro = true;
        }

        if (this.starFinger && this.starFinger.visible) {
            this.starFinger.visible = false;
            this._running = true;
            this._happo.state.timeScale = 1;
        }

        this._inputData = event.data;

        if (this._launched && this._starsCollected > 19) {
            if (Math.random() > 0.5) {
                Common.audio.playSound("sfx_happos_ooh_00");
            } else {
                Common.audio.playSound("sfx_happos_cheer_00");
            }
            this.relaunch();

            if (event.target === this._starBtnBack) {
                Common.audio.playSound("sfx_btn_press_00");
                TweenMax.to(this._starBtnBack.scale, 0.25, {
                    x: 0.9,
                    y: 0.9,
                    yoyo: true,
                    repeat: 1,
                    ease: Power0.easeNone
                });
            }
        }

    }

    fixCourse() {
        for (let i = this._objects.length - 2; i < this._objects.length; i++) {
            this._objects[i].x = this._objects[i - 1].x + 600;
        }
    }

    createHappo() {
        const shadow = createSprite("shadow", this._gameHolder);
        let rand = Math.ceil(Math.random() * 4);
        let obj = createSprite("happo_" + rand, this._gameHolder);
        obj.anchor.y = 1;
        obj.scale.set(0.7);
        obj.y = p3.View.height + obj.height - 115;
        obj.tween = TweenMax.to(obj.scale, 1, {
            x: obj.scale.x + 0.02,
            y: obj.scale.y - 0.02,
            ease: Power0.easeNone,
            yoyo: true,
            repeat: -1,
            repeatDelay: 0.15 + Math.random * 0.2,
            delay: Math.random()
        });
        this._happos.push(obj);
        obj.shadow = shadow;
        shadow.scale.set(0.5);
        if (rand === 4) {
            obj.type = "ballerina";
        } else if (rand === 1) {
            obj.type = "worker";
        }
        return obj;
    }

    relaunch() {

        //--emit stars for a few seconds--//
        this._boostReadyEmitter.emit = true;
        delay(()=> {
            this._boostReadyEmitter.emit = false;
        }, 2, this);

        this._happo.finalAnim = false;
        this._happo.killRotate = false;

        //absolute the value and negate for dy so we are always going up with lots of force after a boost
        //this._happo.dy = Math.abs(this._happo.dy);

        if (this._happo.dy > 0) this._happo.dy = 0;

        this._happo.dx += this._boostPower * 0.75;
        this._happo.dy -= this._boostPower;

        this._starsCollected -= 20;
        //this._starsText.text = "" + this._starsCollected;
        // this._fillMask.x = -225 + (150 / 20) * (this._starsCollected % 20);
        //make bar full if we still got more than 20 stars
        if (this._starsCollected >= 20) {
            //  this._fillMask.x = -225 + 150;
        }
        else {//otherwise set bar animations and particles to stop
            this._starBtnFront.texture = Common.assets.getTexture("btn_boost_off");
            this._starTween.kill();
            this._starBtnFront.scale.set(1);
            this._starParticles.emit = false;
            // this._boostReadyEmitter.emit = false;
            this._boostReadyEmitterHappo.emit = false;
            //  this._happo.filters = null;
            this._starBtnBack.filters = null;
        }
    }

    /**
     * @deprecated
     */
    relaunchOld() {
        //console.warn("relaunching");
        const dist = this._starsCollected * 55;
        this._happo.state.setAnimation(0, "flightboost", true);
        this._happo.scale.set(0.3);
        this._happo.rotation = Common.deg2rad(-25);
        this.relaunched = true;

        if (this._objects.length < 4) {
            console.log("extending course");
            // this._objects = [];
            this.extendObstacles(10 + Math.ceil(Math.random() * 5));
        } else {
            console.log("popping front obs");
            this._objects.pop();
            this._objects.pop();
        }

        this._speed = this._speedMax;

        for (let i = 0; i < this._objects.length; i++) {
            this._objects[i].x += dist;
        }
        for (let i = 1; i < this._objects.length; i++) {
            this._objects[i].x += 800;
        }
        let index = 0;
        for (let i = 0; i < this._stars.length; i++) {
            if (!this._stars[i].collected) {
                index = i;
                break;
            }
        }
        for (let i = index + 5; i < this._stars.length; i++) {
            this._stars[i].x += dist + 800;
        }
        this._starsCollected -= 20;
        this._starsText.text = "" + this._starsCollected;
        this._fillMask.x = -225 + (150 / 20) * (this._starsCollected % 20);
        if (this._starsCollected >= 20) this._fillMask.x = -225 + 150; //make bar full
        else {
            this._starTween.kill();
            this._starIcon.scale.set(1);
            this._starParticles.emit = false;
            this._boostReadyEmitter.emit = false;
        }

        this.runCourse();
    }

    extendObstacles(num) {

        this._objects = [];
        //   this._oldObjects.reverse();
        const numObstacles = num;
        let distFromStart = this._happo.x, obs, rand;

        for (let i = 0; i < numObstacles; i++) {

            if (i > 1) {
                if (i < numObstacles - 4) {

                    //  console.log(this._objects[this._objects.length - 1].type);
                    const lastType = this._objects[this._objects.length - 1].type;

                    if (lastType !== "balloons") {

                        if (lastType === "trampoline" ||
                            lastType === "spring" ||
                            lastType === "spring_2" ||
                            lastType === "float") {

                            obs = createSprite("balloons", this._gameHolder);
                            obs.type = "balloons";

                        } else {
                            rand = Math.floor(Math.random() * (Object.keys(this.objTextures).length + this.chanceNoneObs));
                            if (rand < Object.keys(this.objTextures).length) {
                                rand = Math.floor(Math.random() * (Object.keys(this.objTextures).length));
                                obs = createSprite(this.objTextures[rand], this._gameHolder);
                                obs.type = this.objTextures[rand];
                            } else {
                                obs = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
                                obs.type = "none";
                                obs.height = 45;
                            }
                        }

                    } else if (Math.random() < 0.35) {
                        obs = createSprite("balloons", this._gameHolder);
                        obs.type = "balloons";
                    } else {
                        obs = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
                        obs.type = "none";
                        obs.height = 45;
                    }
                } else {
                    obs = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
                    obs.type = "none";
                    obs.height = 45;
                }
            } else {
                obs = createSprite("balloons", this._gameHolder);
                obs.type = "balloons";
            }

            if (i > 0) {
                //todo - this should ensure that the last few obs are type "none" and then set exact distances
                const dist = this.bounceFactors[this._objects[this._objects.length - 1].type] * 100 + Math.round(Math.random() * this.randomObsDist);
                distFromStart += dist;
            }
            obs.anchor.set(0.5, 1);
            obs.position.set(distFromStart, this._floorPosition.y + 50);
            if (obs.type === "balloons") obs.y = -450 - Math.random() * 350;
            this._objects.push(obs);
        }

        this.addStars();
        this._objects.reverse();
    }

    initParticles() {
        let config = Common.assets.getJSON("particles_cannon_1");
        this._cannonEmitter = new PIXI.particles.Emitter(this._gameHolder, [Common.assets.getTexture("smoke")], config);
        this._cannonEmitter.emit = false;
        //this._cannonEmitter.updateSpawnPos(this._cannon.x, this._cannon.y);
        this._cannonEmitter.updateOwnerPos(this._cannon.x, this._cannon.y);
        this._particleEmitters.push(this._cannonEmitter);

        config = Common.assets.getJSON("particle_cannon_directional_blast");
        this._cannonEmitter2 = new PIXI.particles.Emitter(this._gameHolder, [Common.assets.getTexture("smoke")], config);
        this._cannonEmitter2.emit = false;
        //this._cannonEmitter2.updateSpawnPos(this._cannon.x, this._cannon.y);
        this._cannonEmitter2.updateOwnerPos(this._cannon.x, this._cannon.y);
        this._particleEmitters.push(this._cannonEmitter2);

        config = Common.assets.getJSON("particles_splash_water");
        let emitter = new PIXI.particles.Emitter(this._particleHolder, [Common.assets.getTexture("particle_splash_water_01"), Common.assets.getTexture("particle_splash_water_02"), Common.assets.getTexture("particle_splash_water_03"), Common.assets.getTexture("particle_splash_water_04")], config);
        emitter.emit = false;
        this._waterEmitter = emitter;

        config = Common.assets.getJSON("particles_splash_mud");
        emitter = new PIXI.particles.Emitter(this._particleHolder, [Common.assets.getTexture("particle_splash_mud_01"), Common.assets.getTexture("particle_splash_mud_02"), Common.assets.getTexture("particle_splash_mud_03")], config);
        emitter.emit = false;
        this._mudEmitter = emitter;

        config = Common.assets.getJSON("particles_character_boost_ready");
        emitter = new PIXI.particles.Emitter(this._gameHolder, [Common.assets.getTexture("part_star")], config);
        emitter.emit = false;
        this._boostReadyEmitter = emitter;

        // this._gameHolder.addChild(this._happo);

        config = Common.assets.getJSON("particles_dust_ground");
        //num particles 25
        //radius 30
        //endSize 0.4
        // config.radius = 25;
        //  config.
        emitter = new PIXI.particles.Emitter(this._gameHolder, [Common.assets.getTexture("smoke")], config);
        emitter.emit = false;
        this._dustEmitter = emitter;

        let extraContainer = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
        extraContainer.anchor.set(0.5);
        let anotherContainer = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
        anotherContainer.anchor.set(0.5);
        extraContainer.addChild(anotherContainer);
        anotherContainer.scale.set(2);

        this.extraContainer = extraContainer;
        this._gameHolder.addChild(extraContainer);

        config = Common.assets.getJSON("particles_boostmeter");
        emitter = new PIXI.particles.Emitter(anotherContainer, [Common.assets.getTexture("part_star")], config);
        emitter.emit = false;
        this._boostReadyEmitterHappo = emitter;

        this._particleEmitters.push(this._waterEmitter, this._mudEmitter, this._boostReadyEmitter, this._dustEmitter/*, this._boostReadyEmitterHappo*/);
    }

    initUI() {

        var createPauseScreen = () => {

            const screen = createSprite("panel_help", this._uIntHolder);
            screen.anchor.y = 0.5;
            screen.y = p3.View.height * 0.5;

            var muteClick = () => {
                Common.isMute = !Common.isMute;
                Common.audio.mute(Common.isMute);
                if (!Common.isMute) this.soundBtn.icon.texture = Common.assets.getTexture("icon_sound_on");
                else this.soundBtn.icon.texture = Common.assets.getTexture("icon_sound_off");
            };
            this.soundBtn = Common.createButton(p3.View.width * 0.5 - 75, -p3.View.height * 0.5 + 65, "small", muteClick, this, screen, "icon_sound_off");
            if (!Common.isMute) this.soundBtn.icon.texture = Common.assets.getTexture("icon_sound_on");

            var homeClick = () => {
                this.signals.home.dispatch(this);
            };
            const btnHome = Common.createButton(-p3.View.width * 0.5 + 75, -p3.View.height * 0.5 + 65, "small", homeClick, this, screen, "icon_home");

            const btnPlay = Common.createButton(p3.View.width * 0.5 - 100, p3.View.height * 0.5 - 100, "big", this.pauseClick, this, screen, "icon_play");
            const btnReplay = Common.createButton(-p3.View.width * 0.5 + 100, p3.View.height * 0.5 - 100, "big", ()=> {
                this.signals.previous.dispatch(this);
            }, this, screen, "icon_replay");

            //add help screens
            let frames;
            if (!p3.Device.isMobile) {
                frames = [createSprite("tutorial_fr_1_desktop", screen), createSprite("tutorial_fr_2_desktop", screen), createSprite("tutorial_fr_3", screen)];
            } else {
                frames = [createSprite("tutorial_fr_1_mobile", screen), createSprite("tutorial_fr_2_mobile", screen), createSprite("tutorial_fr_3", screen)];
            }

            for (let i in frames) {
                frames[i].anchor.set(0.5);
                // frames[i].y += 35;
                frames[i].visible = false;
            }

            let txtFrames = [], pips = [];
            for (let i = 0; i < 3; i++) {
                let append;
                if (!p3.Device.isMobile) {
                    append = "_desk";
                } else {
                    append = "_mob";
                }

                let textConfig = {
                    fontFamily: "arial",
                    fontSize: "27px",
                    fill: 0x6a9bd5,
                    align: "center",
                    wordWrap: true,
                    wordWrapWidth: screen.width - 290
                };

                if (Common.language !== "en") {
                    textConfig.fontSize = "22px";
                }

                let txt;

                txt = new PIXI.Text(Common.copy["help_fr_" + (i + 1) + "_desk"][Common.language], textConfig);
                txt.anchor.set(0.5);
                txtFrames.push(txt);
                txt.y = screen.height * 0.5 - 110;
                txt.visible = false;
                const pip = createSprite("pip_on", screen);
                pip.y = screen.height * 0.5 - 38;
                pip.visible = false;
                pip.anchor.set(0.5);
                pips.push(pip);
                screen.addChild(txt);
            }

            pips[0].x = -55;
            pips[0].visible = true;
            pips[pips.length - 1].x = 55;

            let frNum = 0;
            var changeFrame = (dir)=> {
                frames[frNum].visible = false;
                txtFrames[frNum].visible = false;
                pips[frNum].visible = false;
                frNum += dir;
                if (frNum > frames.length - 1) frNum = 0;
                if (frNum < 0)frNum = frames.length - 1;
                frames[frNum].visible = true;
                txtFrames[frNum].visible = true;
                pips[frNum].visible = true;
            };
            changeFrame(0);

            const leftPanel = createSprite("panel_arrow_holder_l", screen);
            const rightPanel = createSprite("panel_arrow_holder_r", screen);

            const btnLeft = Common.createButton(-screen.width * 0.5 + 75, 45, "small", ()=> {
                changeFrame(-1);
            }, this, screen, "icon_next");
            btnLeft.icon.scale.x = -1;

            const btnRight = Common.createButton(screen.width * 0.5 - 75, 45, "small", ()=> {
                changeFrame(1);
            }, this, screen, "icon_next");

            this.pauseScreen = screen;
            screen.visible = false;

            leftPanel.x = btnLeft.x - 2;
            //leftPanel.y = btnLeft.y + btnLeft.height * 0.5 + 15;
            rightPanel.x = btnRight.x + 2;
            leftPanel.y = rightPanel.y = btnRight.y - btnLeft.height * 0.5 - 15;
            //leftPanel.scale.x = -1;


            this.leftPanel = leftPanel;
            this.leftBtn = btnLeft;

        };

        var createPanels = () => {
            /*
             const starPanel = createSprite("stars_panel", this._uIntHolder);
             starPanel.x = -p3.View.width * 0.5 + starPanel.width * 0.5 + 15;
             starPanel.y = 15;
             this._starsText = new PIXI.Text("" + this._starsCollected, {
             fontFamily: "arial",
             fontSize: "33px",
             fill: "white"
             });
             this._starsText.anchor.set(0.5);
             this._starsText.x = starPanel.width * 0.5 - 40;
             this._starsText.y = starPanel.height * 0.5 - 2;
             starPanel.addChild(this._starsText);
             const starFill = createSprite("stars_panel_fill");
             this._starPanel = starPanel;

             let star = createSprite("stars_panel_icon", starPanel);
             star.anchor.set(0.5);
             star.x = -starPanel.width * 0.5 + star.width * 0.5 + 8;
             star.y = starPanel.height * 0.5;
             this._starIcon = star;

             //add particles
             const config = Common.assets.getJSON("particles_boostmeter");
             let partEmitter = new PIXI.particles.Emitter(starPanel, [Common.assets.getTexture("part_star")], config);
             partEmitter.updateSpawnPos(star.x, star.y);
             partEmitter.emit = false;
             this._starParticles = partEmitter;
             //emitter.updateSpawnPos(banner.x, banner.y);
             this._particleEmitters.push(partEmitter);

             var myMask = new PIXI.Graphics();
             myMask.beginFill();
             myMask.drawRect(0, 0, 150, starFill.height);
             myMask.endFill();
             myMask.x = -225;


             starPanel.addChild(myMask, starFill);
             //   this.addChild(myMask, starFill);

             starFill.mask = myMask;

             this._maskStartX = myMask.x;
             this._fillMask = myMask;
             //mask 150 px
             */

            const starBtnBk = createSprite("btn_boost_bg", this._uIntHolder);
            //    const starBtnFill = Common.generateEllipse(50, 50, 0xf0f889f);
            //  starBtnFill.anchor.set(0.5, 0);
            // starBtnBk.addChild(starBtnFill);

            starBtnBk.x = -p3.View.width * 0.5 + starBtnBk.width * 0.5 + 25;
            starBtnBk.y = p3.View.height - starBtnBk.height - 25;
            starBtnBk.anchor.set(0.5);

            starBtnBk.visible = false;

            const emitter = new PIXI.particles.Emitter(this._uIntHolder, [Common.assets.getTexture("part_star")], this._starBurstConfig);
            emitter.updateOwnerPos(starBtnBk.x, starBtnBk.y);
            emitter.emit = false;
            this._starBtnEmitter = emitter;
            this._particleEmitters.push(emitter);

            //  if (this._graphics) this._gameHolder.removeChild(this._graphics);

            var rad = 52;
            this._graphics = new PIXI.Graphics();
            this._graphics.pivot.set(0.5);

            this._graphics.x = -rad * 0.5 - 5;
            this._graphics.y = -starBtnBk.height * 0.5 + 25;
            this._graphicsY = this._graphics.y;

            // this._graphics.clear();
            this._graphics.lineStyle(21, 0xffe011);
            this._currentFill = -Math.PI * 0.5;
            ///  this._currentFill += (2 * Math.PI);
            this._graphics.arc(32, 57, rad, -Math.PI * 0.5, this._currentFill);
            //  .//  this._gameHolder.addChild(this._graphics);
            starBtnBk.addChild(this._graphics);
            const starBtnFront = createSprite("btn_boost_off", starBtnBk);
            starBtnFront.anchor.set(0.5, 0.5);

            this._starBtnFront = starBtnFront;
            this._starBtnBack = starBtnBk;

            this._starBtnBack.interactive = true;
            this._starBtnBack.mousedown = this._starBtnBack.touchstart = this.inputDown.bind(this);

            const config = Common.assets.getJSON("particles_boostmeter");
            let partEmitter = new PIXI.particles.Emitter(starBtnBk, [Common.assets.getTexture("part_star")], config);
            //  partEmitter.updateSpawnPos(0, starBtnBk.height * 0.5);
            partEmitter.emit = false;
            this._starParticles = partEmitter;
            //emitter.updateSpawnPos(banner.x, banner.y);
            this._particleEmitters.push(partEmitter);

            let count = 0;
            var test = ()=> {
                count++;
                console.log("count : " + count);
                this._starBtnBack.removeChild(this._graphics);
                this._graphics.clear();
                this._graphics.destroy();
                this._graphics = new PIXI.Graphics();
                this._graphics.pivot.set(0.5);
                this._graphics.x = -rad * 0.5 - 4.5;
                // this._graphics.y = rad * 0.5 - 1;
                this._graphics.lineStyle(21, 0xffe011);
                this._currentFill += (2 * Math.PI) / 20;
                this._graphics.arc(32, 57, rad, -Math.PI * 0.5, this._currentFill);
                this._starBtnBack.addChild(this._graphics, starBtnFront);
                //   delay(test, 1, this);
            };
            //test();


            const distPanel = createSprite("distance_panel", this._uIntHolder);
            distPanel.x = -p3.View.width * 0.5 + distPanel.width * 0.5 + 15;
            distPanel.y = 15;
            this._distanceText = new PIXI.Text("" + this._starsCollected, {
                fontFamily: "arial",
                fontSize: "33px",
                fill: "white"
            });
            this._distanceText.anchor.set(0.5);
            this._distanceText.x = distPanel.width * 0.5 - 55;
            this._distanceText.y = distPanel.height * 0.5 - 2;
            distPanel.addChild(this._distanceText);

            this._distPanel = distPanel;
        };

        createPanels();
        createPauseScreen();

        this.pauseBtn = Common.createButton(p3.View.width * 0.5 - 75, 65, "small", this.pauseClick, this, this._uIntHolder, "icon_pause");

    }

    pauseClick() {
        this.pauseBtn.interactive = !this.pauseBtn.interactive;

        this._distPanel.visible = !this._distPanel.visible;
        //this._starPanel.visible = !this._starPanel.visible;
        Common.paused = !Common.paused;

        if (this._launched) this._starBtnBack.visible = !this._starBtnBack.visible;

        if (Common.paused) {
            this._alien.state.timeScale = 0;
            this.pauseBtn.visible = false;
            this.pauseBtn.renderable = false;
            this.pauseScreen.visible = true;
            this.starterHappo.autoUpdate = false;
            this._running = false;
            this._happo.autoUpdate = false;
            TweenMax.pauseAll();
            this._mapHolder.filters = this._blurFilter;
            this._distanceText.visible = false;
            //     this._starsText.visible = false;
            this._sky.interactive = false;
        } else {
            this._alien.state.timeScale = 1;
            this.pauseBtn.visible = true;
            this.pauseBtn.renderable = true;
            this.pauseScreen.visible = false;
            this.starterHappo.autoUpdate = true;
            this._running = true;
            this._happo.autoUpdate = true;
            TweenMax.resumeAll();
            this._mapHolder.filters = null;
            this._distanceText.visible = true;
            //    this._starsText.visible = true;
            this._sky.interactive = true;
            this.justUnpaused = true;
            delay(()=> {
                this.justUnpaused = false;
            }, 1.5, this);
        }
    }

    gameOver() {
        //console.log("game over");
        TweenMax.killAll();
        Common.audio.stopMusic("music_ready_loop_012");
        Common.audio.stopSound("sfx_ambient_desert_loop_00");
        Common.audio.playSound("music_results_short_00");
        Common.flyDist = this._totalDist;
        // this.gameFinished = true;

        this._starParticles.emit = false;
        //this._happo.filters = null;
        this._boostReadyEmitter.emit = false;
        for (let i = 0; i < 3; i++) {
            if (this._totalDist > Common.highScores[i]) {
                Common.highScores.splice(i, 0, this._totalDist);
                Common.highScores.pop();
                Common.sort(Common.highScores, true);
                Common.saveGame();
                break;
            }
        }
        delay(()=> {
            //console.log("ending");
            this.end()
        }, 2, this);
    }

    destroy() {
        TweenMax.killAll();

        //loop through display objects and destroy
        for (let i = 0; i < disp.length; i++) {
            disp[i].destroy();
            disp[i] = null;
            delete disp[i];
        }
        disp.length = 0;

        for (let i = 0; i < this._containers.length; i++) {
            this._containers[i].destroy();
            this._containers[i] = null;
            delete this._containers[i];
        }
        this._containers.length = 0;

        for (let i = 0; i < this._particleEmitters.length; i++) {
            this._particleEmitters[i].destroy();
            this._particleEmitters[i] = null;
            delete this._particleEmitters[i];
        }
        this._particleEmitters.length = 0;
        Common.renderer.plugins.sprite.sprites.length = 0;

        super.destroy();
    }

    resize() {
        this.x = p3.View.width * 0.5;
        const bgTiles = this._sky;
        bgTiles.width = p3.View.width * 2;
        bgTiles.height = p3.View.height * 2.5;

        //  const starPanel = this._starPanel;
        //  starPanel.x = -p3.View.width * 0.5 + starPanel.width * 0.5 + 15;

        const distPanel = this._distPanel;
        distPanel.x = -p3.View.width * 0.5 + distPanel.width * 0.5 + 15;

        this.pauseBtn.x = p3.View.width * 0.5 - 75;

        //   const leftPanel = this.leftPanel;
        //  leftPanel.y = this.leftBtn.y + this.leftBtn.height * 0.5 + 15;
        //   leftPanel.scale.x = 1;
    }
}

function createSprite(texture, holder) {
    let sprite;
    if (typeof texture === "string") sprite = new PIXI.Sprite(Common.assets.getTexture(texture));
    else if (texture instanceof PIXI.Texture) sprite = new PIXI.Sprite(texture);
    else {
        //console.warn("texture neither a string nor a PIXI.Texture, falling back to empty texture");
        sprite = new PIXI.Sprite(PIXI.Texture.EMPTY);
    }
    sprite.anchor = {x: 0.5, y: 0};
    if (holder) holder.addChild(sprite);
    Common.displayObjs.push(sprite);
    disp.push(sprite);

    return sprite;
}

function getTex(name) {
    return Common.assets.getTexture(name);
}